import { useEffect } from 'react';

import { env } from '@/shared/config/env';

/**
 * Names the browser tab after the section the user is actually in.
 *
 * <p>The app sets one title at boot (`env.appName`), which is right for a single-page shell and wrong the
 * moment a merchant has three portal tabs open — every one of them reads "Merchant Portal". A section that
 * calls this owns the tab while it is mounted and hands the previous title back on the way out, so the
 * effect is scoped to the section rather than leaking into whatever the user opens next.
 *
 * @param title the section's own name, already translated. An empty string leaves the title alone.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = `${title} · ${env.appName}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
